import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the italic icon
 * 
 * @param {Object} props - The props of the component
 * @returns The italic icon
 */
const ItalicIcon = (props) => (
  <Icon viewBox="0 0 9 10" {...props}>
    <path d="M0.333496 9.66683V8.00016H3.00016L5.00016 2.00016H2.3335V0.333496H9.00016V2.00016H6.66683L4.66683 8.00016H7.00016V9.66683H0.333496Z" fill="currentColor" />
  </Icon>
);

export default React.memo(ItalicIcon);
